/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Frontend JSON Schemas 

const _FRONTEND_GENERAL_SETTINGS_JSON_SCHEMA = {
    "$ref": "#/definitions/FrontendGeneralSettingsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "FrontendGeneralSettingsSchema": {
            "additionalProperties": false,
            "properties": {
                "settings_uid": {
                    "title": "Settings Uid",
                    "type": "string"
                },
                "site_offline": {
                    "title": "Site Offline",
                    "type": "boolean"
                }
            },
            "required": [
                "settings_uid",
                "site_offline"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _ONLINE_USER_JSON_SCHEMA = {
    "$ref": "#/definitions/OnlineUserSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "OnlineUserSchema": {
            "additionalProperties": false,
            "properties": {
                "access_token": {
                    "title": "Access Token",
                    "type": "string"
                },
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "ip_address_string": {
                    "title": "Ip Address String",
                    "type": "string"
                },
                "is_ghost": {
                    "title": "Is Ghost",
                    "type": "boolean"
                },
                "last_login_refresh_timestamp": {
                    "format": "date-time",
                    "title": "Last Login Refresh Timestamp",
                    "type": "string"
                },
                "last_login_timestamp": {
                    "format": "date-time",
                    "title": "Last Login Timestamp",
                    "type": "string"
                },
                "online_user_uid": {
                    "reference_type": "uuid",
                    "title": "Online User Uid",
                    "type": "string",
                    "uid_resource_type": "online_user"
                },
                "refresh_count": {
                    "format": "integer",
                    "title": "Refresh Count",
                    "type": "number"
                },
                "refresh_token": {
                    "title": "Refresh Token",
                    "type": "string"
                },
                "refresh_token_expire_timestamp": {
                    "format": "date-time",
                    "title": "Refresh Token Expire Timestamp",
                    "type": "string"
                },
                "stay_logged_in": {
                    "title": "Stay Logged In",
                    "type": "boolean"
                },
                "user_agent_string": {
                    "title": "User Agent String",
                    "type": "string"
                }
            },
            "required": [
                "access_token",
                "account_uid",
                "ip_address_string",
                "is_ghost",
                "last_login_refresh_timestamp",
                "last_login_timestamp",
                "online_user_uid",
                "refresh_count",
                "refresh_token",
                "refresh_token_expire_timestamp",
                "stay_logged_in",
                "user_agent_string"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": [
                    "ip_address_string",
                    "user_agent_string",
                    "stay_logged_in",
                    "is_ghost",
                    "access_token",
                    "refresh_token"
                ]
            }
        }
    }
};


export const FRONTEND_GENERAL_SETTINGS_JSON_SCHEMA = _FRONTEND_GENERAL_SETTINGS_JSON_SCHEMA.definitions.FrontendGeneralSettingsSchema;
export const ONLINE_USER_JSON_SCHEMA = _ONLINE_USER_JSON_SCHEMA.definitions.OnlineUserSchema;
